import { render, staticRenderFns } from "./waybillRecord.vue?vue&type=template&id=d4aaf51c&"
import script from "./waybillRecord.vue?vue&type=script&lang=js&"
export * from "./waybillRecord.vue?vue&type=script&lang=js&"
import style0 from "./waybillRecord.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "waybillRecord.vue"
export default component.exports